import React from "react";
import { Link } from "react-router-dom";
import { FileText, ArrowLeft } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import SEO from "../components/SEO";

const TermsConditions = () => {
  const { lPath } = useLanguage();
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <SEO
        title="Terms & Conditions | S.K. Woollens"
        description="Terms & Conditions of S.K. Woollens. Review the commercial terms governing our B2B raw wool supply contracts."
        keywords="terms and conditions, S.K. Woollens terms"
        canonicalUrl="https://skwoolens.trivanahospitality.com/en/terms"
      />
      <Link
        to={lPath("/")}
        className="inline-flex items-center gap-1.5 text-xs font-semibold text-wool-bronze hover:text-wool-bronze-dark transition"
      >
        <ArrowLeft className="w-3.5 h-3.5" />
        <span>Return to Home</span>
      </Link>

      <div className="bg-white border border-wool-border rounded-3xl p-8 sm:p-12 shadow-subtle space-y-6">
        <div className="space-y-2 border-b border-wool-border/60 pb-4">
          <div className="wool-badge">
            <FileText className="w-3.5 h-3.5 text-wool-bronze" />
            <span>Commercial Terms</span>
          </div>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-wool-charcoal font-display">
            Terms & Conditions
          </h1>
          <p className="text-xs text-wool-muted">
            S.K. Woollens — B2B Raw Wool Supply & Sourcing Framework
          </p>
        </div>

        <div className="space-y-4 text-xs sm:text-sm text-wool-slate leading-relaxed">
          <h3 className="text-base font-bold text-wool-charcoal">1. Business-to-Business Scope</h3>
          <p>
            S.K. Woollens operates strictly as a B2B raw wool trading and supply enterprise based in Bikaner, Rajasthan, India. All website information, specifications, and inquiry mechanisms are intended solely for commercial entities, yarn manufacturers, spinning mills, and international wool exporters/brokers.
          </p>

          <h3 className="text-base font-bold text-wool-charcoal">2. Quotations & Specification Tolerance</h3>
          <p>
            All price indications, lot volumes, micron grades (including 30+ and 32–34+ micron ranges), staple lengths, and clean yield percentages are confirmed via individual commercial proforma invoices or contracts agreed upon by the partners and the buyer/supplier.
          </p>

          <h3 className="text-base font-bold text-wool-charcoal">3. International Sourcing Engagements</h3>
          <p>
            Inquiries submitted through the International Supplier Portal are evaluated on a case-by-case commercial basis. Submission of details does not constitute a binding purchase contract until formally executed by S.K. Woollens partners.
          </p>

          <h3 className="text-base font-bold text-wool-charcoal">4. Intellectual Property & Brand Identity</h3>
          <p>
            "S.K. Woollens" and associated brand materials are the commercial property of the firm. The historical association with Bulakichand Kesarichand represents our founding 1965 heritage.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
